module.exports = __webpack_public_path__ + "img/lottery-subtitle.1254a71b.png";